import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 16 13",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.4 9.5h.7c.2 0 .4-.2.4-.4V1.9c0-.2-.2-.4-.4-.4h-.7c-.2 0-.4.2-.4.4v7.2c0 .2.2.4.4.4Zm-6 0h.7c.2 0 .4-.2.4-.4V2.9c0-.2-.2-.4-.4-.4h-.7c-.2 0-.4.2-.4.4v6.2c0 .2.2.4.4.4Zm3 0h.7c.2 0 .4-.2.4-.4V4.9c0-.2-.2-.4-.4-.4h-.7c-.2 0-.4.2-.4.4v4.2c0 .2.2.4.4.4Zm6.1 1.5h-14V1A.5.5 0 0 0 1 .5H.5A.5.5 0 0 0 0 1v10.5a1 1 0 0 0 1 1h14.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5ZM3.4 9.5h.7c.2 0 .4-.2.4-.4V6.9c0-.2-.2-.4-.4-.4h-.7c-.2 0-.4.2-.4.4v2.2c0 .2.2.4.4.4Z" }, null, -1)
  ]))]))
}
export default { render: render }